export default "__VITE_ASSET__DBZAlmyW__"